<template>
  <div class="main">
    <img src="../assets/img/LOGO@2x.png" alt="" class="loginLogo" />
	<!-- <div style="width: 2000px; height: 1000px;">
		<iframe style="width: 1000px; height: 500px;" src="http://localhost:8081/#/login?appid=18660391341"></iframe>
	</div> -->
	<!-- <div style="width: 2000px; height: 1000px;">
		<iframe style="width: 1500px; height: 200px;" src="http://localhost:8084/#/thirdLogin?path=system&appid=18400000000&appSecret=HgPsVtRNrdtdfckKEjgkMA%3D%3D&subPath=home"></iframe>
		<iframe style="width: 1500px; height: 200px;" src="http://localhost:8084/#/thirdLogin?path=system&appid=18400000000&appSecret=HgPsVtRNrdtdfckKEjgkMA%3D%3D&subPath=realTimeMonitor"></iframe>
		<iframe style="width: 1500px; height: 200px;" src="http://localhost:8084/#/thirdLogin?path=system&appid=18400000000&appSecret=HgPsVtRNrdtdfckKEjgkMA%3D%3D&subPath=oldHealthy"></iframe>
		<iframe style="width: 1500px; height: 200px;" src="http://localhost:8084/#/thirdLogin?path=system&appid=18400000000&appSecret=HgPsVtRNrdtdfckKEjgkMA%3D%3D&subPath=record"></iframe>
	</div> -->
    <div class="popup">
      <!-- <h1>清雷-康养管理系统</h1> -->
      <h1>
        贝加安<span
          style="display: inline-block;font-size: 12px; position: relative; top: -19px; width: 15px;
    text-align: center;
    height: 15px;
    border: 1px solid;
    border-radius: 50%;
    line-height: 14px;"
          >R</span
        >智慧生命支持系统
      </h1>
      <a-form>
        <a-form-item label="">
          <div
            class="login_input"
            style="margin-bottom: 20px"
            :style="{ borderColor: color1 }"
          >
            <input
              type="text"
              maxlength="11"
              v-model="account"
              placeholder="请输入您的账号"
              @input="accountChange"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="accountType"
            />
          </div>
          <p v-if="accountType">{{ title }}</p>
        </a-form-item>
        <a-form-item label="">
          <div class="login_input" :style="{ borderColor: color2 }">
            <input
              type="password"
              placeholder="请输入您的密码"
              v-model="password"
              @input="passwordChange"
              @keyup.enter="submitForm"
              v-if="showEyes"
            />
            <input
              type="text"
              placeholder="请输入您的密码"
              v-model="password"
              v-if="!showEyes"
              @input="passwordChange"
              @keyup.enter="submitForm"
            />
            <a-icon
              type="info-circle"
              theme="filled"
              style="color: #ff4d4f"
              v-if="passwordType"
            />
            <img
              src="../assets/check.png"
              @click="changeEeys(true)"
              alt=""
              v-if="!showEyes && !passwordType"
              class="eyes"
            />
            <img
              src="../assets/path.png"
              @click="changeEeys(false)"
              alt=""
              v-if="showEyes && !passwordType"
              class="eyes2"
            />
          </div>
          <p style="margin-top: 18px" v-if="passwordType">
            请输入密码
          </p>
        </a-form-item>
        <a-form-item style="margin-top: 46px; text-align: right">
          <a-button
            type="primary"
            class="loginBtn"
            :loading="loading"
            @click="submitForm"
            >登录</a-button
          >
          <!-- <a-button type="primary"  @click="goPath(1)">管理员端</a-button> -->
          <!-- <a-button type="primary"  @click="goPath(2)">院长端</a-button> -->
          <!-- <a-button type="primary"  @click="goPath(3)">护工端</a-button> -->
        </a-form-item>
      </a-form>
    </div>
  </div>
</template>

<script>
import { encryption } from '../utils/crypto';
import closeMes from '../utils/clearTime.js';
export default {
  data() {
    return {
      account: '',
      password: '',
      color1: '#d9d9d9', // 账号颜色控制
      color2: '#d9d9d9', // 密码颜色控制
      accountType: false, // 账号提示语控制
      passwordType: false, // 账号提示语控制
      title: '',
      loading: false,
      showEyes: true,
    };
  },
  created() {
    localStorage.setItem('index1', 1);
    localStorage.setItem('index2', 1);
  },
  mounted() {
		localStorage.setItem('SystemName', null);

    let audio = document.getElementById('music');
    if (!audio) {
      let video = document.createElement('audio');
      video.src = './assets/video/sound_Alarm.mp3';
      video.id = 'music';
      video.style.cssText = 'display:none';
      video.controls = 'controls';
      video.loop = 'loop';
      let body = document.body;
      body.appendChild(video);
    } else {
      let audio = document.getElementById('music');
      audio.volume = 0;
      // audio.pause();
    }
  },
  methods: {
	threePartyLogin(params) {
		console.log('===www===', params)
		this.submitForm()
	},
    changeEeys(flag) {
      this.showEyes = flag;
    },
    goPath(type) {
      console.log(111);
      if (type == 1) {
        this.$router.replace({
          path: '/admin',
        });
      } else if (type == 2) {
        this.$router.replace({
          path: '/dean',
        });
      } else if (type == 3) {
        this.$router.replace({
          path: '/protect',
        });
      } else {
        this.$router.replace({
          path: '/superAdmin',
        });
      }
    },
    // 登录
    submitForm() {
      if (!this.account) {
        this.color1 = '#FF4D4F';
        this.accountType = true;
        this.title = '请输入账号';
        return;
      } else {
        this.color1 = '#1890FF';
        this.accountType = false;
      }
      let phoneReg = /^1[3456789]\d{9}$/;
      // 手机号验证

      if (!phoneReg.test(this.account)) {
        this.color1 = '#FF4D4F';
        this.accountType = true;
        this.title = '请输入正确的手机账号';
        return;
      } else {
        this.color1 = '#1890FF';
        this.accountType = false;
      }
      if (!this.password) {
        this.color2 = '#FF4D4F';
        this.passwordType = true;
        return;
      } else {
        this.color2 = '#1890FF';
        this.passwordType = false;
      }
      let param = `?password=${encodeURIComponent(
        encryption(this.password)
      )}&username=${this.account}`;
      this.loading = true;
      this.$loginpost(
        '/api/login' + param,
        {},
        (res) => {
			document.cookie = "isHiddenTopNav=0"
          console.log(res);
          if (res.code == 0) {
            var d = new Date();
            let c = 86400 / res.expires_in;
            d.setDate(d.getDate() + c);
            document.cookie =
              'userInfo' +
              '=' +
              encodeURIComponent(JSON.stringify(res.data)) +
              ';expires=' +
              d.toGMTString() +
              '; path=/';
            this.$store.commit('stateFun', {
              name: 'user_info',
              val: res.data.user,
            });
            localStorage.setItem('audioval', 1);
            console.log(res.data.user.roleId);
            if (res.data.user.roleId == 1) {
              this.$message.success('登录成功！', 1.5);
              this.$router.replace({
                path: '/admin',
              });
            } else if (res.data.user.roleId == 2) {
              this.$message.success('登录成功！', 1.5);
              this.$router.replace({
                path: '/dean',
                //path:"dean/realTimeMonitor",
              });
            } else if (res.data.user.roleId == 3) {
              this.$router.replace({
                path: '/protect',
              });
            } else {
              this.$message.success('登录成功！', 1.5);
              this.$router.replace({
                path: '/superAdmin',
              });
            }
            let audio = document.getElementById('music');
            audio.play();
            audio.volume = 0;
          } else {
            this.$message.error(res.msg);
            this.color1 = '#FF4D4F';
            this.color2 = '#FF4D4F';
            this.accountType = true;
            this.passwordType = true;
            this.title = '账号和密码不匹配';
            closeMes(3000);
          }
          this.loading = false;
        },
        (err) => {
          this.loading = false;
          console.log(err);
          // this.$message.error('服务端发生异常');
        }
      );
    },
    // 监听账号输入
    accountChange(e) {
      if (this.account) {
        this.color1 = '#1890FF';
        this.accountType = false;
      } else {
        this.color1 = '#FF4D4F';
        this.accountType = true;
        this.title = '请输入账号';
      }
    },
    // 监听密码输入
    passwordChange(e) {
      if (this.password) {
        this.color2 = '#1890FF';
        this.passwordType = false;
      } else {
        this.color2 = '#FF4D4F';
        this.passwordType = true;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.main {
  height: 100vh;
  width: 100%;
  // height: 100%;
  background: url('../assets/img/img_loginbg@2x.png') no-repeat center;
  background-size: cover;
  .loginLogo {
    width: 268px;
    height: 73px;
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    left: 220px;
  }

  .popup {
    width: 514px;
    height: 350px;
    background: #ffffff;
    border-radius: 14px;
    position: fixed;
    top: 50%;
    transform: translate(0, -50%);
    right: 100px;
    padding: 0 50px;
    box-sizing: border-box;
    // display: flex;
    .div {
      width: 100px;
      cursor: pointer;
    }
    h1 {
      color: #000000;
      font-size: 24px;
      padding: 40px 0;
    }
    p {
      font-size: 14px;
      color: #ff4d4f;
      padding: 0;
      margin: 0;
      line-height: 0;
    }
    .loginBtn:hover {
      background: #0072db;
    }
  }
  .login_input {
    display: flex;
    position: relative;
    width: 100%;
    height: 16px;
    padding-bottom: 13px;
    border-bottom: 1px solid;
    box-sizing: content-box;
    img {
      width: 16px;
      height: 16px;
      margin: 0 22px 0 16px;
    }
    input {
      flex: 1;
      border: 0; // 去除未选中状态边框
      outline: none; // 去除选中状态边框
      background-color: rgba(0, 0, 0, 0) !important;
      padding-right: 46px;
      height: 16px !important;
      line-height: 16px !important;
    }
    input:-webkit-autofill {
      transition: background-color 5000s ease-in-out 0s;
    }
    .cu {
      cursor: pointer;
    }
    .eyes {
      width: 18px;
      height: auto;
      margin: auto;
      position: relative;
      top: 0px;
      cursor: pointer;
    }
    .eyes2 {
      width: 18px;
      height: auto;
      margin: auto;
      cursor: pointer;
      position: relative;
      top: 2px;
    }
  }
}
</style>
